const CheckboxField = ({
  label,
  name,
  checked,
  onChange,
  hint = "",
  disabled = false,
}) => (
  <div>
    <label
      className={`inline-flex items-start gap-2 text-sm group ${
        disabled ? "text-gray-400 cursor-not-allowed" : "text-gray-700 cursor-pointer"
      }`}
    >
      <input
        type="checkbox"
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="mt-0.5 h-4 w-4 accent-blue-600 rounded cursor-pointer disabled:cursor-not-allowed"
      />
      <span className={disabled ? "" : "group-hover:text-gray-900 transition-colors"}>
        {label}
      </span>
    </label>
    {hint && <p className="text-xs text-gray-500 mt-1 ml-6">{hint}</p>}
  </div>
);

export default CheckboxField;
